import './public-path.ts'
import Vue from 'vue'
// import arms from './arms'
import Collie from 'collie-front-monitor'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins'
import './filters'
import './components'
import './styles/index.scss'
import './utils/preventReClick'
// eslint-disable-next-line @typescript-eslint/no-var-requires
const { name } = require('../package')
let instance = null
Vue.config.productionTip = false
function render (props: any = {}) {
  const w = window as any
  w.$qiankunRp = props.parentWindow && props.parentWindow.$qiankunRp
  const { container } = props
  props.onGlobalStateChange && props.onGlobalStateChange((state: any, prev: any) => {
    store.commit('app/setAuthorities', state.perms[name])
    if (state.platId) {
      sessionStorage.setItem('platId', state.platId)
    }
    w.closeTab = w.$qiankunRp && w.$qiankunRp.close
  }, true)
  instance = new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount(container ? container.querySelector('#app') : '#app')
}

// 独立运行时
if (!(window as any).__POWERED_BY_QIANKUN__) {
  render()
}

export async function bootstrap () {
  console.log('[vue] vue app bootstraped')
}
export async function mount (props: any) {
  render(props)
}
export async function unmount () {
  instance.$destroy()
  instance.$el.innerHTML = ''
  instance = null
}
